import { FC } from "react";
import { Link, Stack, Typography } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { ResourceType } from "@/services/cloudchipr.api";
import { getResourceTypeName } from "@/utils/helpers/resources/getResourceTypeName";

interface LiveUsageResourceInfoStatusForSingleAccountProps {
  resourceType: ResourceType;
}

export const LiveUsageResourceInfoStatusForSingleAccount: FC<
  LiveUsageResourceInfoStatusForSingleAccountProps
> = ({ resourceType }) => {
  return (
    <Stack alignItems="center" justifyContent="center" py={8}>
      <Stack direction="row" spacing={1} alignItems="center">
        <WarningAmberIcon color="info" fontSize="small" />
        <Typography variant="h6" fontWeight="medium">
          Resource Collection Failed
        </Typography>
      </Stack>

      <Typography variant="body2">
        We couldn’t collect your{" "}
        {getResourceTypeName(resourceType, { type: "long" })} during the last
        attempt.
      </Typography>

      <Typography variant="body2">
        Please check for missing permissions or reach out to us at{" "}
        <Link
          href="mailto:support@cloudchipr.com"
          underline="hover"
          target="_blank"
        >
          support@cloudchipr.com
        </Link>{" "}
        for help.
      </Typography>
    </Stack>
  );
};
